<template lang="pug">
    tr.white--text(v-if="validAgent" :class="[getClassName()]")
        td.no-wrap.sm-md-width
            template(v-if="hasMoreThanOneTeam")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            | {{ partialTeamNames }}
                    span
                        | {{ fullTeamNames }}

            template(v-else) {{ partialTeamNames }}

        td.no-wrap.md-width(:style="{ left: actualFirstColumnWidth + 'px'}") {{ agent.user_full_name }}
        td.no-wrap.xl-width {{ agent.agent_status_name }}
        td.no-wrap.sm-md-width
            div(v-if="(agent.time_in_seconds || 0) < 600")
                strong {{ (agent.time_in_seconds || 0) | secondsToFullWords }}

            v-tooltip(top v-else)
                template(v-slot:activator='{ on, attrs }')
                    span(v-bind="attrs" v-on="on" role="text")
                        Timeago(
                            :datetime="agent.agent_created_at"
                            :auto-update="60"
                        )
                span {{ (agent.time_in_seconds || 0) | secondsToFullWords }}

        td.no-wrap.sm-width {{ (agent.inbound_calls_today || 0) | number }}
        td.no-wrap.sm-width {{ (agent.outbound_calls_today || 0) | number }}
        td.no-wrap.sm-width {{ (agent.appointments_created_today || 0) | number }}
        td.no-wrap.sm-md-width {{ (agent.total_assigned_return_message_campaign_customers || 0) | number }}
        td.no-wrap.sm-width
            div(v-if="validUnrespondedToTimeInSeconds")
                strong {{ (agent.unresponded_to_time_in_seconds || 0) | secondsToFullWords }}
            div(v-else) N/a
        td.no-wrap.sm-width
            div(v-if="agent.organization_id > 0")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            | {{ agent.organization_name | str_limit(35) }}
                    span
                        | {{ agent.organization_name }}
            div(v-else) N/a
        td.no-wrap.sm-width
            div(v-if="agent.campaign_id > 0")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            | {{ agent.campaign_name | str_limit(35) }}
                    span
                        | {{ agent.campaign_name }}
            div(v-else) N/a

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
            getClassName() {
                // alert error
                if (this.seconds >= 300) {
                    return "alert-error-background-color";
                }

                // alert warning
                if (this.seconds >= 180) {
                    return "alert-warning-background-color";
                }

                // alert success
                return "alert-success-background-color"
            },
            prepareTeamNames(teamIDs) {

                // Init
                const teamNames = [];

                // Verify team IDs are present
                if (!(teamIDs?.length > 0) || !(this.teams?.length > 0)) {
                    return teamNames;
                }

                // Loop through team IDs and find team names
                for (let i = 0; i < teamIDs.length; i++) {

                    // Init
                    const teamID = teamIDs[i];
                    if (teamID <= 0) {
                        continue;
                    }

                    // Loop through teams
                    for (let j = 0; j < this.teams.length; j++) {

                        // Init
                        const team = this.teams[j];
                        if (!team && !(team.team_id > 0)) {
                            continue;
                        }

                        // Check if team ID matches
                        if (team.team_id !== teamID) {
                            continue;
                        }

                        // Append team name into array
                        teamNames.push(team.name);
                        break;
                    }
                }

                return teamNames;
            },
        },
        computed: {
            actualFirstColumnWidth() {
                return this.firstColumnWidth > 0 ? this.firstColumnWidth : 175;
            },
            fullTeamNames() {

                // Verify team IDs are present
                if (!(this.agent?.team_ids?.length > 0)) {
                    return "---";
                }

                // Build team names
                const names = this.prepareTeamNames(this.agent?.team_ids);
                if (!(names?.length > 0)) {
                    return "---";
                }

                return names.join(", ");
            },
            hasMoreThanOneTeam() {
                return this.agent?.team_ids?.length > 1;
            },
            partialTeamNames() {

                // Verify team IDs are present
                if (!(this.agent?.team_ids?.length > 0)) {
                    return "---";
                }

                // Build team names
                const names = this.prepareTeamNames(this.agent?.team_ids);
                if (!(names?.length > 0)) {
                    return "---";
                }

                return this.hasMoreThanOneTeam ? names[0] + " + " + (names.length - 1) : names[0];
            },
            seconds() {
                return (this.agent?.time_in_seconds || 0);
            },
            validAgent() {
                return this.agent?.account_user_id > 0;
            },
            validUnrespondedToTimeInSeconds() {
                return this.agent?.unresponded_to_time_in_seconds !== null && this.agent?.unresponded_to_time_in_seconds !== undefined;
            },
        },
        components: {
        },
        props: {
            agent: Object,
            firstColumnWidth: Number,
            teams: Array,
        },
    });
</script>

<style lang="scss" scoped>

#app {
        tr.alert-error-background-color {
            background-color: var(--error) !important;
        }
        .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr.alert-error-background-color:hover {
            background-color: var(--lt-red) !important;
        }

        tr.alert-warning-background-color {
            background-color: var(--orange) !important;
        }
        .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr.alert-warning-background-color:hover {
            background-color: var(--warning) !important;
        }

        tr.alert-success-background-color {
            background-color: var(--success) !important;
        }
        .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr.alert-success-background-color:hover {
            background-color: var(--lt-green) !important;
        }
    }
</style>